module.exports = __webpack_public_path__ + "tv3sportdk-e785d4b60aceb7511f8565e057e03924.jpeg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/tv3sportdk.jpeg
// module id = 1154
// module chunks = 0 1